import { Injectable } from '@angular/core';
import type { ApiParams } from '@shared/http/api-params';
import { Fetcher } from '../../http/fetcher';
import type { Shift } from './shift';

@Injectable({
    providedIn: 'root',
})
export class ShiftFetcher extends Fetcher<Shift> {
    readonly modelName = 'Shift';

    get resourceName(): string {
        return 'shifts';
    }

    setAttended(shiftId: string, attended: boolean, params: ApiParams = {}) {
        return this.patch(shiftId, { attended }, params);
    }
}
